var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loginFormIsVisible)?_c('af-overlay',{attrs:{"content-class":"register__content"}},[_c('af-login-form')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }